export enum QueryType {
  RawSql = "raw_sql",
  Visual = "visual",
  Table = "table",
  DbtModel = "dbt_model",
  DbtCloudModel = "dbt_cloud_model",
  LookerLook = "looker_look",
  Custom = "custom",
  Sigma = "sigma",
  JourneyNode = "journey-node",
  DecisionEngine = "decision-engine",
  IDRGoldenRecord = "idr-golden-record",
  IDRGoldenRecordParent = "idr-golden-record-parent",
  // Predictor (predictive traits) based query. We use the custom query type to hide it from the schema layer and to
  // inject the predictor's base audience into the query when a predictive trait is used.
  Predictive = "predictive",
  CepManagedModel = "cep-managed-model",
  /**
   * Hightouch-managed model that produces the warehouse-side values of a parent model's
   * realtime traits.
   */
  RealtimeTraitWarehouseState = "realtime_trait_warehouse_state",
  /**
   * Hightouch-managed model backing an LCM dynamic-content deployment: the
   * parent model plus one compiled boolean column per slot branch. The segment
   * row stores only the content email reference; branch conditions are read
   * fresh from shared slot libraries at query build, so condition edits apply
   * on the next run without redeploying.
   */
  LcsTriggeredSend = "lcs-triggered-send",
  /**
   * Hightouch-managed model with one row per normalized delivery handle that a
   * CEP suppression list matches. `custom_query` holds only the list id.
   */
  CepSuppressionList = "cep-suppression-list",
}

export const ManagedQueryTypes = [
  QueryType.JourneyNode,
  QueryType.DecisionEngine,
  QueryType.IDRGoldenRecord,
  QueryType.IDRGoldenRecordParent,
  QueryType.Predictive,
  QueryType.CepManagedModel,
  QueryType.RealtimeTraitWarehouseState,
  QueryType.LcsTriggeredSend,
  QueryType.CepSuppressionList,
] as const;

export function isQueryType(
  type: string | null | undefined,
): type is QueryType {
  return Object.values(QueryType).includes(type as QueryType);
}

export function isManagedQueryType(
  type: string | null | undefined,
): type is ManagedQueryType {
  return ManagedQueryTypes.includes(type as any);
}

export type ManagedQueryType = (typeof ManagedQueryTypes)[number];
